module.exports = __webpack_public_path__ + "img/border_right_long.b964db5e.svg";